module.exports = __webpack_public_path__ + "static/media/next10years.e54010e7.jpg";